var React = require('react');

function Orangemark (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.0546875 28.7363H12.5547V20.2207C12.5547 14.0879 14.5859 9.2832 17.5156 4.67383L10.1719 0.337891C4.74219 4.75195 0.0546875 13.1504 0.0546875 20.2988V28.7363ZM19.7812 28.7363H32.2812V20.2207C32.2812 14.0879 34.3125 9.2832 37.2422 4.67383L29.8984 0.337891C24.4688 4.75195 19.7812 13.1504 19.7812 20.2988V28.7363Z","fill":"#FF5D00"}));
}

Orangemark.defaultProps = {"width":"38","height":"29","viewBox":"0 0 38 29","fill":"none"};

module.exports = Orangemark;

Orangemark.default = Orangemark;
